import { useEffect, useState } from 'react';

/** Búsqueda local: espera a que el usuario deje de tipear (ms) antes de filtrar. */
export const SEARCH_DEBOUNCE_MS = 200;

/**
 * Valor demorado `delay` ms. Vacío se aplica al instante (limpiar no espera).
 * @template T
 * @param {T} value
 * @param {number} [delay]
 * @returns {T}
 */
export function useDebouncedValue(value, delay = SEARCH_DEBOUNCE_MS) {
  const [debounced, setDebounced] = useState(value);
  const isEmpty = value == null || (typeof value === 'string' && value.trim() === '');
  useEffect(() => {
    if (isEmpty) {
      setDebounced(value);
      return undefined;
    }
    const timer = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(timer);
  }, [value, delay, isEmpty]);
  return isEmpty ? value : debounced;
}
